<script lang="ts">
  import Button from "$lib/components/Button/Button.svelte";
  import Container from "$lib/components/Container/Container.svelte";
  import NavMenuOverlay from "$lib/components/Nav/NavMenuOverlay/NavMenuOverlay.svelte";
  import TopSpacer from "$lib/components/TopSpacer/TopSpacer.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";

  import { _ } from "svelte-i18n";
  export let items;
</script>

<style lang="scss">
  .plp {
    &--empty {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding-top: 2rem;

      &--content {
        padding-top: 2rem;
      }

      &-btn {
        padding: 2rem 0 2rem 0;
      }
    }

    &--empty-banner {
      width: 100%;
    }
  }

  :global(.plp--empty-banner > .nav-menu-overlay) {
    position: relative !important;
    left: 0 !important;
    border: none !important;
  }
  :global(.plp--empty) {
    padding-top: 0 !important;
  }

  :global(.plp--empty-banner > .nav-menu-overlay) {
    border: 0.5px solid #17120f !important;
    border-bottom: none !important;
  }

  :global(.plp--empty-banner-two .nav-menu-overlay--wrapper) {
    grid-template-columns: repeat(1, 1fr) !important;
    @include breakpoint(md) {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }

  :global(.plp--empty-banner-four .nav-menu-overlay--wrapper) {
    grid-template-columns: repeat(1, 1fr) !important;
    @include breakpoint(md) {
      grid-template-columns: repeat(4, 1fr) !important;
    }
  }

  :global(.nav-menu-overlay--border) {
    border-right: none !important;
    @include breakpoint(md) {
      border-right: 1px solid rgba(23, 18, 15, 0.1);
    }
  }

  :global(.nav-link-list--item) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include breakpoint(md) {
      display: block;
    }
  }

  .no-results {
    &--bar {
      height: 51px;
      background-color: $inverse-surface;
      display: block;
      z-index: 1002;
      position: relative;
    }
  }
</style>

<TopSpacer />
<div class="no-results no-results--bar" />
<div class="plp--empty">
  <Container>
    <div class="plp--empty--content">
      <Typography>{$_("noSales.content")}</Typography>
    </div>
  </Container>
  <div class="plp--empty-btn">
    <Button href={"/"} label={$_("Continue shopping")} primary />
  </div>
  <div
    class={`plp--empty-banner ${
      items?.length > 2 ? "plp--empty-banner-four" : "plp--empty-banner-two"
    }`}
  >
    <NavMenuOverlay
      menuOverlayOpen={true}
      navItems={items}
      dark={false}
      bg={false}
    />
  </div>
</div>
